import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=33bfbee4&scoped=true&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=33bfbee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfbee4",
  null
  
)

export default component.exports